import { memo, useEffect, useState } from "react";

import Stack from "@mui/material/Stack";

import { useConnectionStore } from "stores/ConnectionStore";
import { ActionState } from "stores/lib";

import { getConnectedServices } from "utility/connections";

import Sources from "external/sources";

import ConnectedService from "components/ConnectedService";

import Loading from "./Loading";

// -----------------------------------------------------------------------------

const EnvironmentConnectedSources = memo(
  function EnvironmentConnectedSources() {
    const [store] = useConnectionStore();
    const [connections, setConnections] = useState<any>([]);

    useEffect(() => {
      if (store.loadConnections.state === ActionState.COMPLETED) {
        setConnections(store.connections);
      }
    }, [store.loadConnections.state, store.connections]);

    //
    return (
      <Stack direction="column" spacing={1}>
        {store.loadConnections.state === ActionState.IN_PROGRESS ? (
          <Loading />
        ) : (
          getConnectedServices(connections, Sources.services).map(
            ({ connection, service }) => {
              return (
                <ConnectedService
                  connection={connection}
                  service={service}
                  key={connection.uuid}
                />
              );
            }
          )
        )}
      </Stack>
    );
  }
);

export default EnvironmentConnectedSources;
